export function stringToDate(timeString: string): Date {
	const [hours, minutes, seconds] = timeString.split(":").map(Number);
	const date = new Date();
	date.setHours(hours, minutes, seconds, 0);
	return date;
}

export const formatTimeWithoutSeconds = (timeString: string | undefined): string => {
	if (!timeString) return "Hora no válida";

	const [hours, minutes] = timeString.split(":").map(Number);

	if (isNaN(hours) || isNaN(minutes)) {
		return "Hora no válida";
	}

	return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
};
